import {
    ADD_CATEGORY_FAIL,
    ADD_CATEGORY_SUCCESS,
    DELETE_CATEGORY_FAIL,
    DELETE_CATEGORY_SUCCESS,
    BULK_DELETE_CATEGORY_FAIL,
    BULK_DELETE_CATEGORY_SUCCESS,
    EXPORT_CATEGORY_FAIL,
    EXPORT_CATEGORY_SUCCESS,
    GET_CATEGORY_DETAILS_FAIL,
    GET_CATEGORY_DETAILS_SUCCESS,
    GET_CATEGORY_LISTING_FAIL,
    GET_CATEGORY_LISTING_SUCCESS,
    RESET_CATEGORY_ATTACHMENT_STATE,
    RESET_CATEGORY_STATE,
    UPDATE_CATEGORY_FAIL,
    UPDATE_CATEGORY_SUCCESS,
    BULK_UPDATE_CATEGORY_FAIL,
    BULK_UPDATE_CATEGORY_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
    categoryListing: [],
    categoryDetails: [],
    addCategory: [],
    updateCategory: [],
    bulkUpdateCategory: [],
    deleteCategory: [],
    bulkDeleteCategory: [],
    exportCategory: [],
    error: [],
}

const Category = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CATEGORY_LISTING_SUCCESS:
            return {
                ...state,
                categoryListing: action.payload
            }
        case GET_CATEGORY_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_CATEGORY_DETAILS_SUCCESS:
            return {
                ...state,
                categoryDetails: action.payload
            }
        case GET_CATEGORY_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_CATEGORY_SUCCESS:
            return {
                ...state,
                addCategory: action.payload
            }
        case ADD_CATEGORY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_CATEGORY_SUCCESS:
            return {
                ...state,
                updateCategory: action.payload
            }
        case UPDATE_CATEGORY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case BULK_UPDATE_CATEGORY_SUCCESS:
            return {
                ...state,
                bulkUpdateCategory: action.payload
            }
        case BULK_UPDATE_CATEGORY_FAIL:
            return {
                ...state,
                error: action.payload,
                bulkUpdateCategory: action.payload,
            }

        case DELETE_CATEGORY_SUCCESS:
            return {
                ...state,
                deleteCategory: action.payload
            }
        case DELETE_CATEGORY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case BULK_DELETE_CATEGORY_SUCCESS:
            return {
                ...state,
                bulkDeleteCategory: action.payload
            }
        case BULK_DELETE_CATEGORY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_CATEGORY_SUCCESS:
            return {
                ...state,
                exportCategory: action.payload
            }
        case EXPORT_CATEGORY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_CATEGORY_STATE:
            return {
                ...state,
                categoryListing: [],
                categoryDetails: [],
                addCategory: [],
                updateCategory: [],
                bulkUpdateCategory: [],
                deleteCategory: [],
                bulkDeleteCategory: [],
                exportCategory: [],
                error: [],
            }
        case RESET_CATEGORY_ATTACHMENT_STATE:
            return {
                ...state,
                exportCategory: [],
                error: [],
            }
        default:
            return state
    }
}

export default Category
